import React, { useState, useEffect } from 'react';
import styles from '../../styles/ReportesFinancierosStyles/ReportesFinancieros.module.css';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

function ReportFilters({ filters, onFilterChange, onGenerate }) {
  const [campusList, setCampusList] = useState([]);
  const [seccionesList, setSeccionesList] = useState([]);
  const [programasList, setProgramasList] = useState([]);
  const [yearsList, setYearsList] = useState([]);

  useEffect(() => {
    loadDropdowns();
  }, []);

  const loadDropdowns = async () => {
    const token = localStorage.getItem('authToken');
    const headers = {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    };
    try {
      const [campusRes, seccionesRes, programasRes, aniosRes] = await Promise.all([
        fetch(`${API_BASE}/catalogos/campus/?activo=true`, { headers }),
        fetch(`${API_BASE}/catalogos/secciones-academicas/`, { headers }),
        fetch(`${API_BASE}/escolar/programas-academicos/`, { headers }),
        fetch(`${API_BASE}/financiero/reportes/becas/anios/`, { headers }),
      ]);

      const campusData = await campusRes.json();
      setCampusList(Array.isArray(campusData) ? campusData : (campusData.results || []));

      const seccionesData = await seccionesRes.json();
      setSeccionesList(Array.isArray(seccionesData) ? seccionesData : (seccionesData.results || []));

      const programasData = await programasRes.json();
      setProgramasList(Array.isArray(programasData) ? programasData : (programasData.results || []));

      const aniosData = await aniosRes.json();
      const anios = Array.isArray(aniosData.anios) ? aniosData.anios : [];
      setYearsList(anios);
    } catch (error) {
      console.error('Error cargando dropdowns:', error);
    }
  };

  return (
    <div className={styles.filtersSection}>
      <div className={styles.filtersRow}>
        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Campus</label>
          <select
            className={styles.filterSelect}
            value={filters.id_campus}
            onChange={e => onFilterChange('id_campus', e.target.value)}
          >
            <option value="">Todos los campus</option>
            {campusList.map(c => (
              <option key={c.id_campus} value={c.id_campus}>{c.nombre_campus}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Sección</label>
          <select
            className={styles.filterSelect}
            value={filters.id_seccion}
            onChange={e => onFilterChange('id_seccion', e.target.value)}
          >
            <option value="">Todas las secciones</option>
            {seccionesList.map(s => (
              <option key={s.id_seccion} value={s.id_seccion}>{s.nombre_seccion}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Programa</label>
          <select
            className={styles.filterSelect}
            value={filters.id_programa}
            onChange={e => onFilterChange('id_programa', e.target.value)}
          >
            <option value="">Todos los programas</option>
            {programasList.map(p => (
              <option key={p.id_programa} value={p.id_programa}>{p.nombre_programa}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Año</label>
          <select
            className={styles.filterSelect}
            value={filters.anio}
            onChange={e => onFilterChange('anio', e.target.value)}
          >
            <option value="">Selecciona un año</option>
            {yearsList.map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        </div>

        <button
          className={styles.generateButton}
          onClick={onGenerate}
          disabled={!filters.anio}
        >
          Generar Reporte
        </button>
      </div>
    </div>
  );
}

export default ReportFilters;
